export default __webpack_public_path__ + "static/media/6.08404da6.webp";